import React from 'react'
import { IssuingCardDetails } from './issuingCardDetails'

export const IssuingCardDetail = () => {
  return (
    <IssuingCardDetails />
  )
}
